import { Component, Input, OnInit } from '@angular/core';
import { Client } from '@app/common/models';
import { UntilDestroy } from '@ngneat/until-destroy';

@UntilDestroy()
@Component({
  selector: 'pl-client-link',
  styleUrls: ['./pl-client-link.component.scss'],
  templateUrl: './pl-client-link.component.html',
})
export class PlClientLinkComponent implements OnInit {
  readonly clientDetailLink = 'clients/details';

  @Input() client: Client;

  @Input() showLink: boolean;

  tooltip: string;

  ngOnInit() {
    if (this.client?.grade_display) {
      this.tooltip = `${this.client?.grade_display} Grade`;
    }
  }
}
